import React, { useState } from 'react'
import ReactModal from 'react-modal'
import axios from 'axios'
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { creaModalidad } from '../Services/Rest';
import Swal from 'sweetalert2';
//impoertacion componentes

function CrearModalidad() {
    const cookie = new Cookies();
    const [modalIsOpen, setIsOpen] = useState(false);
    const handleOpenModalTest = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };



    const [postDescripcion, setPostDescripcion] = useState([]);
    const postData = e => {
        e.preventDefault(e)
        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
            method: 'post',
            url: creaModalidad,
            data: {
            
                descripcion: postDescripcion,
             

            }
        })
            .then((Response) => {
                console.log(Response.data)
                Swal.fire({  
                    title: 'Guardado con exito!',  
                    text: 'Añadido.',
                    icon: 'success',
                    timer:3500
                  });
                window.location.reload("/")

            }).catch((error) => {
                Swal.fire({  
                    title: 'Error en los campos',  
                    text: 'Intente de nuevo.',
                    icon: 'warning',
                    timer:3500
                  });
            })
    };
    return (
        <div className="test">
            <button variant="contained" className='btn btn-primary' color="primary" onClick={handleOpenModalTest} > Nueva </button>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Crear ">

                <div className="container">
                    <div className="text-center">
                        <div class="container-fluid">
                            <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Crear Modalidad</h6>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive"></div>
                                    <form className="user">
                                    
                                        <div className="form-group row">
                                        <div className="col-sm-12">
                                                <label for="exampleFormControlTextarea1">Descripcion</label>
                                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="6" onChange={(e) => setPostDescripcion(e.target.value)}required></textarea>
                                            </div>
                                        </div>
                                       
                                       
                                        <a ><button className="btn btn-primary btn-user btn-block" type='submit' onClick={postData}>Guardar</button></a>
                                        <hr className="sidebar-divider" />
                                      <a></a>
                                        <hr />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>

        </div>
    )
}
export default CrearModalidad;
